export const serviceInfo = [
  {
    title: "Frontend Developer",
    img: "Front",
    text: "Crafting captivating user experiences with pixel-perfect designs. From sleek interfaces to seamless interactions, turning ideas into stunning frontend realities that engage and delight users.",
  },

  {
    title: "Backend Developer",
    img: "Back",
    text: "Building the digital backbone of your website with expertise ensuring data security, speed, and functionality. Seamlessly connect your frontend to a powerful, reliable backend system.",
  },
  {
    title: "Graphic Designer",
    img: "Design",
    text: "Transforming concepts into captivating visuals. From eye-catching logos to impactful illustrations and incredible social media posters, breatjing life into your brand's identity.",
  },
];
